export default "assets/images/underline_green-e7de4445.svg";